export default __webpack_public_path__ + "static/media/worker1.ebf96503.jpeg";